import { render, staticRenderFns } from "./CustomerJobs.vue?vue&type=template&id=2737bf99&"
import script from "./CustomerJobs.vue?vue&type=script&lang=js&"
export * from "./CustomerJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports